// extracted by mini-css-extract-plugin
module.exports = {"spin":"_1LXXgagx2f","content":"hVNMXa2UUc","wx-app-info":"SIu9my4hTn","info-right":"sY0SM74BRQ"};